export function normalizeOfflineTimeScale(value: number): number {
  return Number.isFinite(value) && value >= 0 ? value : 1;
}
